import { GetBackground, logos } from '../utils/logos';

export const styles = {
  container: {
    backgroundImage: `${GetBackground()}`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    margin: '0',
    position: 'fixed',
    display: 'flex',
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'top',
    variant: 'standard',
    left: '0',
    top: '0',
    overflow: 'auto',
  },
  logo1: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    width: '100%',
    marginTop: '15px',
    bottom: '0px',
  },
  logo2: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    width: '100%',
    top: '3px',
    zIndex: '-1',
  },
  input: {
    width: '100%',
  },
  p: {
    border: '2px solid #e6e6e6',
    width: '73px',
    height: '59px',
    overflow: 'hidden',
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    marginTop: '9px',
    wordWrap: 'break-word',
    fontSize: '16px',
    fontFamily: 'Pokemon Emerald Regular',
    cursor: 'default',
  },
  pCries: {
    border: '4px solid #e6e6e6',
    width: '340px',
    height: '3.2em',
    overflow: 'hidden',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    marginTop: '2px',
    wordWrap: 'break-word',
    fontSize: '24px',
    fontFamily: 'Pokemon Emerald Regular',
    cursor: 'default',
    margin: '15px',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  audio: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  pokeBox1: {
    display: 'flex',
    justifyContent: 'center',
    maxWidth: '100vw',
    marginBottom: '25px',
  },
  pokeBox2: {
    width: '90%',
    maxWidth: '380px',
    minHeight: '45px',
    verticalAlign: 'middle',
    border: '4px #94ccf7 solid',
    borderRadius: '10px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    background: '#6eb4f5',
    margin: '15px auto',
    boxSizing: 'border-box',
    paddingRight: '14px',
  },
  pokeBox3: {
    width: '100%',
    maxWidth: '375px',
    minHeight: '45px',
    background: '#fff',
    borderRadius: '8px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    padding: '1px',
    margin: '0px 7px',
    display: 'block',
    boxSizing: 'border-box',
  },
  pokeBox4: {
    width: '100%',
    maxWidth: '375px',
    minHeight: '45px',
    background: '#fff',
    borderRadius: '8px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    display: 'block',
  },
  pokeBox5: {
    margin: '10px',
    marginTop: '10px',
    textAlign: 'left',
    color: '#606060',
    fontSize: '120%',
    lineHeight: '1.5em',
    padding: '0px 8px',
    wordWrap: 'break-word',
    overflow: 'hidden',
    fontFamily: 'Pokemon Emerald Latin FC',
  },

  pokeBoxAudio1: {
    display: 'flex',
    justifyContent: 'center',
    maxWidth: '105vw',
  },
  pokeBoxAudio2: {
    width: '90%',
    maxWidth: '422px',
    minHeight: '45px',
    verticalAlign: 'middle',
    border: '4px #94ccf7 solid',
    borderRadius: '10px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    background: '#6eb4f5',
    margin: '20px auto',
    boxSizing: 'border-box',
    paddingRight: '25px',
  },
  pokeBoxAudio3: {
    width: '100%',
    maxWidth: '540px',
    minHeight: '45px',
    background: '#fff',
    borderRadius: '8px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    padding: '1px',
    margin: '0px 13px',
    display: 'block',
    boxSizing: 'border-box',
  },
  pokeBoxAudio4: {
    width: '100%',
    maxWidth: '570px',
    minHeight: '45px',
    background: '#fff',
    borderRadius: '8px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    display: 'block',
  },
  pokeBoxEmoji1: {
    display: 'flex',
    justifyContent: 'center',
    maxWidth: '125vw',
    fontFamily: 'Pokemon Emerald Regular',
  },
  pokeBoxEmoji2: {
    width: '100%',
    maxWidth: '380px',
    minWidth: '380px',
    minHeight: '45px',
    verticalAlign: 'middle',
    border: '4px #94ccf7 solid',
    borderRadius: '10px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    background: '#6eb4f5',
    margin: '20px auto',
    boxSizing: 'border-box',
    paddingRight: '25px',
  },
  pokeBoxEmoji3: {
    width: '100%',
    maxWidth: '636px',
    minHeight: '45px',
    background: '#fff',
    borderRadius: '8px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    padding: '1px',
    margin: '0px 13px',
    display: 'inline-block',
    boxSizing: 'border-box',
  },
  pokeBoxEmoji4: {
    width: '100%',
    maxWidth: '696px',
    minHeight: '45px',
    background: '#fff',
    borderRadius: '8px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    display: 'inline-block',
  },

  pokeBoxShare1: {
    display: 'flex',
    justifyContent: 'center',
    maxWidth: '100vw',
    marginBottom: '10px',
  },
  pokeBoxShare2: {
    width: '90%',
    maxWidth: '450px',
    minHeight: '45px',
    verticalAlign: 'middle',
    border: '4px #94ccf7 solid',
    borderRadius: '10px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    background: '#6eb4f5',
    margin: '20px auto',
    boxSizing: 'border-box',
    paddingRight: '25px',
  },
  pokeBoxShare3: {
    width: '100%',
    maxWidth: '415px',
    minHeight: '45px',
    background: '#fff',
    borderRadius: '8px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    padding: '1px',
    margin: '0px 13px',
    display: 'block',
    boxSizing: 'border-box',
  },
  pokeBoxShare4: {
    width: '100%',
    maxWidth: '440px',
    minHeight: '45px',
    background: '#fff',
    borderRadius: '8px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    display: 'block',
  },
  pokeBoxShare5: {},
  pokeboxGuess1: {
    display: 'block',
    justifyContent: 'center',
    marginTop: '60px',
    marginBottom: '15px',
  },
  pokeboxGuess2: {
    width: '90%',
    maxWidth: '450px',
    minHeight: '45px',
    verticalAlign: 'middle',
    border: '4px #00f898 solid',
    borderRadius: '10px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    background: '#00c8b8',
    boxSizing: 'border-box',
    margin: '15px auto',
  },
  pokeboxGuess3: {
    width: '90%',
    maxWidth: '415px',
    minHeight: '45px',
    background: '#d7f7e2',
    borderRadius: '8px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    padding: '1px',
    margin: '0px auto',
    boxSizing: 'border-box',
    display: 'block',
  },
  pokeboxGuess4: {
    width: '100%',
    maxWidth: '440px',
    minHeight: '45px',
    background: '#f8f8f8',
    borderRadius: '8px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    margin: '0px 0px',
    display: 'block',
  },
  pokeboxGuess5: {
    margin: '10px',
    marginTop: '10px',
    textAlign: 'left',
    color: '#606060',
    fontSize: '120%',
    lineHeight: '1.5em',
    padding: '0px 8px',
    wordWrap: 'break-word',
    overflow: 'hidden',
    fontFamily: 'Pokemon Emerald Latin FC',
  },
  clues: {
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
    justifyItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    margin: '6px',
  },
  clueSpan: {
    fontFamily: 'Pokemon Emerald Regular',
    color: 'grey',
    fontSize: '24px',
    display: ' block',
  },
  modalOpen: {
    overflowY: 'auto',
    marginRight: '19px',
  },
  modalHref: {
    textDecoration: 'none',
  },
  modalColor1: {
    color: '#50bdde',
  },
  modalColor2: {
    color: '#29ab80',
  },
  modalColor3: {
    color: '#64d966',
  },
  modalColor4: {
    color: '#efff42',
  },
  modalColor5: {
    color: '#ff3b3b',
  },
  modalColor6: {
    color: '#70e359',
  },
  trainerInfoBoxMargin: {
    marginLeft: '10px',
  },
  trainerInfoBoxContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  trainerInfoSpan: {
    position: 'absolute',
    right: '10px',
  },
  aboutModalBox: {
    width: '90%',
    maxWidth: '430px',
    minHeight: '45px',
    verticalAlign: 'middle',
    border: '4px #94ccf7 solid',
    borderRadius: '10px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    background: '#6eb4f5',
    margin: '15px auto',
    boxSizing: 'border-box',
    paddingRight: '14px',
  },
  aboutModalBox2: {
    width: '100%',
    maxWidth: '415px',
    minHeight: '45px',
    background: '#fff',
    borderRadius: '8px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    padding: '1px',
    margin: '0px 7px',
    display: 'block',
    boxSizing: 'border-box',
  },
  aboutModalBox3: {
    width: '100%',
    maxWidth: '415px',
    minHeight: '45px',
    background: '#fff',
    borderRadius: '8px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    display: 'block',
  },
  aboutModalTypography: {
    borderBottom: '2px solid black',
    fontFamily: 'Pokemon Emerald Regular',
    paddingBottom: '10px',
    width: '97%',
    display: 'flex',
    alignItems: 'center',
    margin: '16px',
    marginTop: '11px',
  },
  aboutModalTypographyH6: {
    margin: '16px',
    fontFamily: 'Pokemon Emerald Regular',
  },
  aboutModalTypographySmall: {
    margin: '16px',
    fontSize: '14px',
    fontFamily: 'Pokemon Emerald Regular',
  },
  modalOpenStats: {
    marginRight: '15px',
    marginTop: '10px',
  },
  historyContainer: {
    display: 'block',
    alignItems: 'center',
  },
  historySpan: {
    position: 'absolute',
    right: '10px',
  },
  modalOpenHistory: {
    overflowY: 'auto',
    marginRight: '19px',
  },
  modalOpenHowTo: {
    overflowY: 'auto',
  },
  menuBoxContainer1: {
    display: 'flex',
    justifyContent: 'center',
    margin: '10px',
    marginTop: '25px',
  },
  menuBoxContainer2: {
    display: 'flex',
    justifyContent: 'center',
    margin: '10px',
  },
  menuBoxClassic1: {
    width: '266px',
    minHeight: '45px',
    verticalAlign: 'middle',
    border: '2px #606868 solid',
    borderRadius: '8px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    background: '#6C7C7C',
    margin: '15px',
    display: 'block',
  },
  menuBoxClassic2: {
    width: '252px',
    minHeight: '45px',
    background: '#788484',
    borderTopLeftRadius: '2px',
    MozBorderRadiusTopleft: '2px',
    WebkitBorderTopLeftRadius: '2px',
    KhtmlBorderTopLeftRadius: '2px',
    IcabBorderTopLeftRadius: '2px',
    OBorderTopLeftRadius: '2px',
    borderBottomLeftRadius: '2px',
    MozBorderRadiusBottomleft: '2px',
    WebkitBorderBottomLeftRadius: '2px',
    KhtmlBorderBottomLeftRadius: '2px',
    IcabBorderBottomLeftRadius: '2px',
    OBorderBottomLeftRadius: '2px',
    marginLeft: '3px',
    marginRight: '11px',
    display: 'block',
  },
  menuBoxClassic3: {
    width: '247px',
    minHeight: '45px',
    background: '#849090',
    marginLeft: '2px',
    marginRight: '3px',
    display: 'block',
  },
  menuBoxClassic4: {
    width: '245px',
    minHeight: '45px',
    background: '#949C9C',
    marginRight: '2px',
    display: 'block',
  },
  menuBoxClassic5: {
    textAlign: 'left',
    color: '#E4F0F0',
    fontSize: '95%',
    lineHeight: '1.5em',
    padding: '0px 6px',
    wordWrap: 'break-word',
    overflow: 'hidden',
  },
  menuBoxCries1: {
    width: '266px',
    verticalAlign: 'middle',
    border: '2px #4C6C58 solid',
    borderRadius: '8px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    background: '#587C64',
    margin: '15px',
    display: 'flex',
  },
  menuBoxCries2: {
    width: '252px',
    background: '#5C8468',
    borderTopLeftRadius: '2px',
    MozBorderRadiusTopleft: '2px',
    WebkitBorderTopLeftRadius: '2px',
    KhtmlBorderTopLeftRadius: '2px',
    IcabBorderTopLeftRadius: '2px',
    OBorderTopLeftRadius: '2px',
    borderBottomLeftRadius: '2px',
    MozBorderRadiusBottomleft: '2px',
    WebkitBorderBottomLeftRadius: '2px',
    KhtmlBorderBottomLeftRadius: '2px',
    IcabBorderBottomLeftRadius: '2px',
    OBorderBottomLeftRadius: '2px',
    marginLeft: '3px',
    marginRight: '11px',
    display: 'flex',
  },
  menuBoxCries3: {
    width: '247px',
    background: '#64906C',
    marginLeft: '2px',
    marginRight: '3px',
    display: 'flex',
  },
  menuBoxCries4: {
    width: '245px',
    background: '#6CA07C',
    marginRight: '2px',
    display: 'flex',
  },
  menuBoxCries5: {
    textAlign: 'left',
    color: '#E4F0F0',
    fontSize: '95%',
    lineHeight: '1.5em',
    padding: '0px 6px',
    wordWrap: 'break-word',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  menuBoxEmoji1: {
    width: '266px',
    minHeight: '45px',
    verticalAlign: 'middle',
    border: '2px #4C5C74 solid',
    borderRadius: '8px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    background: '#586884',
    margin: '15px',
    display: 'block',
  },
  menuBoxEmoji2: {
    width: '252px',
    minHeight: '45px',
    background: '#60748C',
    borderTopLeftRadius: '2px',
    MozBorderRadiusTopleft: '2px',
    WebkitBorderTopLeftRadius: '2px',
    KhtmlBorderTopLeftRadius: '2px',
    IcabBorderTopLeftRadius: '2px',
    OBorderTopLeftRadius: '2px',
    borderBottomLeftRadius: '2px',
    MozBorderRadiusBottomleft: '2px',
    WebkitBorderBottomLeftRadius: '2px',
    KhtmlBorderBottomLeftRadius: '2px',
    IcabBorderBottomLeftRadius: '2px',
    OBorderBottomLeftRadius: '2px',
    marginLeft: '3px',
    marginRight: '11px',
    display: 'block',
  },
  menuBoxEmoji3: {
    width: '247px',
    minHeight: '45px',
    background: '#687C98',
    marginLeft: '2px',
    marginRight: '3px',
    display: 'block',
  },
  menuBoxEmoji4: {
    width: '245px',
    minHeight: '45px',
    background: '#7490AC',
    marginRight: '2px',
    display: 'block',
  },
  menuBoxEmoji5: {
    textAlign: 'left',
    color: '#E4F0F0',
    fontSize: '95%',
    lineHeight: '1.5em',
    padding: '0px 6px',
    wordWrap: 'break-word',
    overflow: 'hidden',
  },
  statsButton: {
    zIndex: 9,
    maxWidth: '100%',
    minWidth: '21px',
    height: '22px',
    margin: '14px',
    marginRight: '55px',
    marginLeft: '40px',
    '&:hover': {
      transform: 'scale(1.09)',
      transition: 'all 0.1s ease-in-out',
    },
    '&.MuiButtonBase-root:hover': {
      bgcolor: 'transparent',
    },
  },
  emojiSetContainer: {
    position: 'relative',
    margin: '15px',
    marginLeft: '35px',
  },
  historyButton: {
    zIndex: 9,
    maxWidth: '100%',
    width: '21px',
    height: '22px',
    margin: '14px',
    marginRight: '20px',
    marginLeft: '31px',
    '&:hover': {
      transform: 'scale(1.09)',
      transition: 'all 0.1s ease-in-out',
    },
    '&.MuiButtonBase-root:hover': {
      bgcolor: 'transparent',
    },
  },
  howButton: {
    zIndex: 9,
    maxWidth: '100%',
    width: '44px',
    height: '44px',
    '&:hover': {
      backgroundColor: 'transparent',
      transform: 'scale(1.09)',
      transition: 'all 0.1s ease-in-out',
    },
  },
  buttonAboutHoverBox: {
    position: 'absolute',
    top: '140%',
    left: '50%',
    width: '110px',
    color: 'black',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    border: '4px #00f898 solid',
    borderRadius: '8px',
    padding: '7px',
    fontFamily: 'Pokemon Emerald Regular',
    fontSize: '120%',
    textTransform: 'capitalize',
    zIndex: 9,
  },
  infoIconButton: {
    zIndex: '2',
    maxWidth: '100%',
    width: '44px',
    height: '64px',
    '&:hover': {
      backgroundColor: 'transparent',
      transform: 'scale(1.06)',
      transition: 'all 0.1s ease-in-out',
      backgroundImage: `url(${logos.infoIcon})`,
    },
  },
  buttonHoverBox: {
    position: 'absolute',
    top: '170%',
    left: '50%',
    width: '120px',
    transform: 'translate(-50%)',
    backgroundColor: 'white',
    color: 'black',
    border: '4px #00f898 solid',
    borderRadius: '8px',
    padding: '3px',
    fontFamily: 'Pokemon Emerald Regular',
    fontSize: '120%',
    textTransform: 'capitalize',
    zIndex: 99,
  },
  buttonHowHoverBox: {
    position: 'absolute',
    top: '120%',
    left: '50%',
    width: '120px',
    transform: 'translate(-50%)',
    backgroundColor: 'white',
    color: 'black',
    border: '4px #00f898 solid',
    borderRadius: '8px',
    padding: '3px',
    fontFamily: 'Pokemon Emerald Regular',
    fontSize: '120%',
    textTransform: 'capitalize',
    zIndex: 999,
  },
  statsBox1: {
    width: '90%',
    maxWidth: '430px',
    minHeight: '45px',
    verticalAlign: 'middle',
    border: '4px #94ccf7 solid',
    borderRadius: '10px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    background: '#6eb4f5',
    margin: '15px auto',
    boxSizing: 'border-box',
    paddingRight: '14px',
  },
  statsBox2: {
    width: '100%',
    maxWidth: '415px',
    minHeight: '45px',
    background: '#fff',
    borderRadius: '8px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    padding: '1px',
    margin: '0px 7px',
    display: 'block',
    boxSizing: 'border-box',
  },
  statsBox3: {
    width: '100%',
    maxWidth: '415px',
    minHeight: '45px',
    background: '#f8f8f8',
    borderRadius: '8px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    display: 'block',
  },
  statsTypography: {
    fontFamily: 'Pokemon Emerald Regular',
    fontWeight: 'bold',
    paddingBottom: '10px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    margin: '9px',
    marginTop: '11px',
    justifyContent: 'center',
  },
  boxInlineBackground: {
    backgroundColor: 'rgba(0,0,0,0.1)',
    borderRadius: '5px',
    padding: '5px',
    marginBottom: '19px',
    margin: '10px',
    display: 'inline-block',
    overflow: 'hidden',
    position: 'relative',
  },
  statsInlineTypography: {
    fontFamily: 'Pokemon Emerald Regular',
    fontSize: '120%',
    paddingBottom: '10px',
    width: '100%',
    maxHeight: '1px',
    display: 'flex',
    alignItems: 'center',
    margin: '9px',
    marginLeft: '6px',
    marginTop: '20px',
    minWidth: '360px',
    justifyContent: 'space-between',
    wordBreak: 'break-word',
    flex: 1,
  },
  historyBox1: {
    width: '90%',
    maxWidth: '430px',
    minHeight: '45px',
    verticalAlign: 'middle',
    border: '4px #94ccf7 solid',
    borderRadius: '10px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    background: '#6eb4f5',
    margin: '15px auto',
    boxSizing: 'border-box',
    paddingRight: '14px',
  },
  historyBox2: {
    width: '100%',
    maxWidth: '415px',
    minHeight: '45px',
    background: '#fff',
    borderRadius: '8px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    padding: '1px',
    margin: '0px 7px',
    display: 'block',
    boxSizing: 'border-box',
  },
  historyBox3: {
    width: '100%',
    maxWidth: '415px',
    minHeight: '45px',
    background: '#fff',
    borderRadius: '8px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    display: 'block',
  },
  historyTypography: {
    fontFamily: 'Pokemon Emerald Regular',
    fontWeight: 'bold',
    paddingBottom: '10px',
    width: '97%',
    display: 'flex',
    alignItems: 'center',
    margin: '9px',
    marginTop: '11px',
    justifyContent: 'center',
  },
  howToBox1: {
    width: '90%',
    maxWidth: '608px',
    verticalAlign: 'middle',
    border: '4px #00f898 solid',
    borderRadius: '10px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    background: '#00c8b8',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    transform: 'translateY(-5% 8%)',
    margin: '15px auto',
    boxSizing: 'border-box',
    padding: '0 12px',
  },
  howToBox2: {
    width: '100%',
    maxWidth: '582px',
    borderRadius: '8px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    padding: '1px',
    margin: '0px 7px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
  },
  howToBox3: {
    width: '100%',
    maxWidth: '582px',
    background: '#dbdbdb',
    borderRadius: '8px',
    MozBorderRadius: '8px',
    WebkitBorderRadius: '8px',
    KhtmlBorderRadius: '8px',
    IcabBorderRadius: '8px',
    OBorderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '10px',
    color: '#606060',
    fontSize: '120%',
    lineHeight: '1.5em',
    wordWrap: 'break-word',
    fontFamily: 'Pokemon Emerald Latin FC',
  },
  howToVariantH4: {
    borderBottom: '2px solid black',
    fontFamily: 'Pokemon Emerald Regular',
    paddingBottom: '10px',
    width: '97%',
    display: 'flex',
    alignItems: 'center',
    margin: '9px',
    marginTop: '11px',
  },
  howToVariantH5: {
    marginLeft: '9px',
    marginBottom: '3px',
    marginTop: '3px',
    fontFamily: 'Pokemon Emerald Regular',
    fontWeight: 'bold',
  },
  howToVariantH6: {
    marginLeft: '9px',
    marginBottom: '3px',
    marginTop: '3px',
    fontFamily: 'Pokemon Emerald Regular',
    fontWeight: '',
  },
  howToVariantH62: {
    margin: '9px',
    fontFamily: 'Pokemon Emerald Regular',
  },
  howToVariantH63: {
    margin: '9px',
    fontFamily: 'Pokemon Emerald Regular',
    fontWeight: 'bold',
  },
  copyButton: {
    fontFamily: 'Pokemon Emerald Regular',
    fontSize: '30px',
    '&.MuiButtonBase-root:hover': {
      bgcolor: 'transparent',
      transform: 'scale(1.19)',
    },
  },
  copyContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px',
  },
  copyWebsite: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '35px',
  },
  copyText: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '29px',
  },
  copyText2: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '30px',
    mb: '3px',
  },
  copySquares: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'px',
    transform: 'scale(1.65)',
  },
  pre: {
    margin: '85px',
    fontFamily: 'Pokemon Emerald Regular',
  },
  copyTypography1: {
    fontFamily: 'Pokemon Emerald Regular',
    fontSize: '21px',
  },
  copyTypography2: {
    fontFamily: 'Pokemon Emerald Regular',
    fontSize: '24px',
  },
  clock: {
    display: 'flex',
    justifyContent: 'center',
    margin: '16px',
    marginTop: '29px',
    fontFamily: 'Pokemon Emerald Regular',
    fontSize: '28px',
  },
  letterClue: {
    fontSize: '15px',
    width: '116px',
    fontFamily: 'Pokemon Emerald Regular',
    '&.MuiButtonBase-root:hover': {
      bgcolor: 'transparent',
      transform: 'scale(1.1)',
      color: 'grey',
    },
  },
  genClue: {
    fontSize: '15px',
    width: '100px',
    fontFamily: 'Pokemon Emerald Regular',
    '&.MuiButtonBase-root:hover': {
      bgcolor: 'transparent',
      transform: 'scale(1.1)',
      color: 'grey',
    },
  },
  infoButtonDiv: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '50px',
  },
  footer: {
    color: 'lightgrey',
    width: '100%',
    textAlign: 'center',
    marginTop: '10px',
    marginBottom: '30px',
    left: '0',
    right: '0',
    bottom: '0',
  },
  href: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignContent: 'center',
    justifyItems: 'center',
    textDecoration: 'none',
    color: 'black',
    position: 'relative',
    margin: '10px',
  },
  hrefTitleContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  hrefTitle: {
    display: 'block',
    marginLeft: '3px',
  },
  hrefMargin: {
    marginRight: '10px',
  },
  spanHref: {
    fontWeight: 'bold',
    marginLeft: '5px',
    fontFamily: 'Pokemon Emerald Regular',
  },
  loading: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxHeight: '25vh',
  },
  loadingText: {
    fontFamily: 'Pokemon Emerald Regular',
    fontSize: '25px',
    color: 'white',
    margin: '20px',
    textAlign: 'center',
  },
  loadingCircle: {
    display: 'flex',
    justifyContent: 'center',
  },
  emoji: {
    fontSize: '60px',
    userSelect: 'none',
    marginLeft: '7px',
  },
  emojiHover: {
    maxHeight: '0px',
    maxWidth: '20px',
    position: 'absolute',
    top: '-55px',
    left: 125,
    fontSize: '60px',
    userSelect: 'none',
  },
  emojiHover2: {
    maxHeight: '0px',
    maxWidth: '20px',
    position: 'absolute',
    top: '-55px',
    left: 210,
    fontSize: '60px',
    userSelect: 'none',
  },
  emojiText: {
    display: 'flex',
    justifyContent: 'center',
    fontFamily: 'Pokemon Emerald Regular',
    marginTop: '20px',
    marginRight: '20px',
    userSelect: 'none',
  },
  formMargin: {
    margin: '5px',
  },
  ulPadding: {
    padding: '0',
  },
  pokeInfoImg: {
    width: '80px',
    marginLeft: '15px',
  },
  pokeInfoMarginTop: {
    marginTop: '-15px',
  },
  pokeInfoNameSpriteContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  pokeInfoContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '80vw' /* Ancho del contenedor */,
    maxWidth: '800px' /* Ancho máximo del contenedor */,
    margin: '0 auto' /* Centrar el contenedor */,
    boxSizing: 'border-box',
  },
  pokeInfoMargin: {
    marginRight: '7px',
  },
  pokeInfoName: {
    fontFamily: 'Pokemon Emerald Latin FC',
    fontSize: '12px',
    margin: '0',
    color: 'white',
    width: '90px',
    marginTop: '8%',
    right: '10%',
    cursor: 'default',
  },
  pokeInfoSprite: {
    marginRight: '20px',
    marginTop: '17px',
  },
  pokeInfoBoxesContainer: {
    display: 'flex',
    textAlign: 'center',
    color: 'black',
    marginTop: '25px',
    marginRight: '7px',
  },
  pokeInfoTypes: {
    marginRight: '7px',
    maxWidth: '80px',
    whiteSpace: 'initial',
    wordBreak: 'break-all',
  },
  pokeInfoAbilities: {
    marginRight: '7px',
    maxWidth: '80px',
    wordBreak: 'break-all',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  pokeInfoCenter: {
    display: 'flex',
    justifyContent: 'center',
  },
  winnerLetterWincountSpan: {
    fontWeight: 'bold',
    marginLeft: '5px',
  },
  winnerLetterWincountColor: {
    color: '#29ab80',
    margin: '0',
  },
  winnerLetterAHref: {
    display: 'flex',
    alignItems: 'center',
  },
  winnerLetterIconMargin: {
    marginRight: '5px',
  },
  winnerLetterImgMargin: {
    marginRight: '35px',
  },
  winnerLetterBallImg: {
    marginLeft: '20px',
    verticalAlign: 'middle',
  },
  winnerLetterTotalWinsMargin: {
    marginRight: '5px',
  },
  winnerLetterEmojiIconMargin: {
    marginRight: '10px',
  },
  winnerLetterTextContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  winnerLetterSpan: {
    display: 'block',
    marginLeft: '3px',
  },
  winnerLetterAHrefCries: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '19px',
  },
  winnerLetterCenterTopContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '11px',
  },
  winnerLetterTopContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
    marginRight: '32px',
  },
  winnerLetterTopContainer2: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    borderBottom: '2px solid black',
    paddingBottom: '10px',
  },
  winnerLetterText: {
    color: 'black',
    fontSize: '14px',
    marginBottom: '7px',
  },
  winnerLetterPokeName: {
    color: 'black',
    fontSize: '12px',
    marginTop: '7px',
  },
  winnerLetterWinsContainer: {
    fontSize: '13px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px',
    position: 'relative',
  },
  winnerLetterImg: {
    marginRight: '20px',
    verticalAlign: 'middle',
    transform: 'scaleX(-1)',
  },
  winnerLetterHrefContainer: {
    marginTop: '55px',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '25px',
    alignItems: 'center',
  },
  winnerLetterHrefSpan: {
    fontWeight: 'bold',
    marginLeft: '5px',
    fontFamily: 'Pokemon Emerald Regular',
  },
  inputPokemonBoxCenter: {
    marginTop: '11px',
    display: 'flex',
    justifyContent: 'center',
  },
  autoCompleteBoxProps: {
    maxHeight: '225px',
    minWidth: '150px',
    fontSize: '13px',
    fontFamily: 'Pokemon Emerald Latin FC',
    overflow: 'auto',
  },
  autoComplete: {
    width: 205,
    mr: '10px',
  },
  pokeInfoColumnPadding: {
    paddingLeft: '4px',
  },
  pokeInfoColumnPadding2: {
    paddingLeft: '5px',
  },
  inputProps: {
    fontFamily: 'Pokemon Emerald Latin FC',
    width: '100%',
    maxWidth: '205px',
  },
  submitButton: {
    mt: '5px',
    type: 'submit',
    position: 'relative',
    mr: '44px',
    width: '110px',
    fontSize: '16px',
    bottom: '8px',
    fontFamily: 'Pokemon Emerald Latin FC',
    '&.MuiButtonBase-root:hover': {
      bgcolor: 'transparent',
      transform: 'translateY(4px)',
    },
  },
  loadingSubmitCircle: {
    position: 'absolute',
    left: '98px',
  },
  infoTextContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '43vw' /* Ancho del contenedor */,
    margin: '0 auto' /* Centrar el contenedor */,
    transform: 'translateX(100px)',
  },
  infoTextContainerShow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    fontFamily: 'Pokemon Emerald Regular',
    fontSize: '1.3em',
    cursor: 'default',
  },
  infoTextGen: {
    borderBottom: '2px solid #cccccc',
    borderWidth: '3px',
    color: 'white',
    paddingBottom: '11px',
    fontSize: '0.8em',
    display: 'flex',
    justifyContent: 'center',
    fontWeight: 'bold',
    width: '68px',
    position: 'relative',
  },
  infoTextTypes: {
    borderBottom: '1px solid #cccccc',
    borderWidth: '3px',
    color: 'white',
    paddingBottom: '11px',
    fontSize: '0.8em',
    display: 'flex',
    justifyContent: 'center',
    fontWeight: 'bold',
    width: '68px',
    transform: 'translateX(2px)',
  },
  infoTextAbilities: {
    borderBottom: '1px solid #cccccc',
    borderWidth: '3px',
    color: 'white',
    paddingBottom: '11px',
    fontSize: '0.8em',
    display: 'flex',
    justifyContent: 'center',
    fontWeight: 'bold',
    width: '69px',
    transform: 'translateX(2px)',
  },
  infoTextWeight: {
    borderBottom: '1px solid #cccccc',
    borderWidth: '3px',
    color: 'white',
    paddingBottom: '11px',
    fontSize: '0.8em',
    display: 'flex',
    justifyContent: 'center',
    fontWeight: 'bold',
    width: '68px',
    transform: 'translateX(2px)',
  },
  infoTextHeight: {
    borderBottom: '1px solid #cccccc',
    borderWidth: '3px',
    color: 'white',
    paddingBottom: '11px',
    fontSize: '0.8em',
    display: 'flex',
    justifyContent: 'center',
    fontWeight: 'bold',
    width: '68px',
    transform: 'translateX(2px)',
  },
  infoTextStats: {
    borderBottom: '1px solid #cccccc',
    borderWidth: '3px',
    color: 'white',
    paddingBottom: '12px',
    fontSize: '0.77em',
    display: 'flex',
    justifyContent: 'center',
    fontWeight: 'bold',
    width: '69px',
    transform: 'translateX(3px)',
  },
  groupHeader: {
    position: 'sticky',
    fontSize: '20px',
    fontWeight: 'bold',
    fontFamily: 'Pokemon Emerald Regular',
    top: '-10px',
    padding: '5px 10px',
    background: 'white',
  },
  width100: {
    maxWidth: '100%',
  },
};
